import type { RouletteBetType } from '../../../api/games';

export interface RouletteSelection {
  betType: RouletteBetType;
  betValue?: number;
  label: string;
}

const RED = new Set([
  1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36,
]);

const OUTSIDE: RouletteSelection[] = [
  { betType: 'red', label: 'Red' },
  { betType: 'black', label: 'Black' },
  { betType: 'even', label: 'Even' },
  { betType: 'odd', label: 'Odd' },
  { betType: 'low', label: '1–18' },
  { betType: 'high', label: '19–36' },
  { betType: 'dozen', betValue: 1, label: '1st 12' },
  { betType: 'dozen', betValue: 2, label: '2nd 12' },
  { betType: 'dozen', betValue: 3, label: '3rd 12' },
  { betType: 'column', betValue: 1, label: 'Col 1' },
  { betType: 'column', betValue: 2, label: 'Col 2' },
  { betType: 'column', betValue: 3, label: 'Col 3' },
];

function sameSelection(a: RouletteSelection, b: RouletteSelection | null): boolean {
  return !!b && a.betType === b.betType && a.betValue === b.betValue;
}

export function BettingBoard({
  selected,
  onSelect,
  winningNumber,
}: {
  selected: RouletteSelection | null;
  onSelect: (s: RouletteSelection) => void;
  winningNumber: number | null;
}) {
  const numbers = Array.from({ length: 37 }, (_, n) => n); // 0..36

  const numberColor = (n: number) =>
    n === 0 ? 'bg-emerald-700' : RED.has(n) ? 'bg-rose-700' : 'bg-slate-800';

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-6 gap-1 sm:grid-cols-12">
        {numbers.map((n) => {
          const sel: RouletteSelection = {
            betType: 'straight',
            betValue: n,
            label: `${n}`,
          };
          const isWin = winningNumber === n;
          return (
            <button
              key={n}
              onClick={() => onSelect(sel)}
              className={`aspect-square rounded text-sm font-bold text-white transition
                ${numberColor(n)}
                ${sameSelection(sel, selected) ? 'ring-2 ring-gold' : ''}
                ${isWin ? 'animate-pulse ring-4 ring-gold' : ''}`}
            >
              {n}
            </button>
          );
        })}
      </div>

      <div className="grid grid-cols-3 gap-2 sm:grid-cols-6">
        {OUTSIDE.map((o) => (
          <button
            key={o.label}
            onClick={() => onSelect(o)}
            className={`btn-ghost py-2 text-sm ${
              sameSelection(o, selected) ? 'ring-2 ring-gold' : ''
            }`}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}
